import { sendGet } from '../helpers/axiosBwf';

export const apiGetHrListType = () => sendGet('/api/v1/hr-list-type');
export const apiGetHrListCategory = () => sendGet('/api/v1/hr-list-category');
